import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaKaggle, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black text-white p-8 mt-8">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="flex flex-col items-center md:items-start">
          <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
          <p className="mb-2"><a href="mailto:amitkedia3000@gmail.com" className="text-white hover:text-green-500 transition-all duration-500 hover:underline" target="_blank" rel="noopener noreferrer">amitkedia3000@gmail.com</a></p>
        </div>
        <div className="flex flex-col items-center md:items-start">
          <h2 className="text-2xl font-bold mb-4">Follow Me</h2>
          <p className="mb-2 flex items-center">
            <FaLinkedin className="mr-2" />
            <a href="https://www.linkedin.com/in/theamitkedia/" className="text-white hover:text-green-500 transition-all duration-500 hover:underline" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </p>
          <p className="mb-2 flex items-center">
            <FaGithub className="mr-2" />
            <a href="https://github.com/amitkedia007" className="text-white hover:text-green-500 transition-all duration-500 hover:underline" target="_blank" rel="noopener noreferrer">GitHub</a>
          </p>
          <p className="mb-2 flex items-center">
            <FaKaggle className="mr-2" />
            <a href="https://www.kaggle.com/amitkedia" className="text-white hover:text-green-500 transition-all duration-500 hover:underline" target="_blank" rel="noopener noreferrer">Kaggle</a>
          </p>
          <p className="mb-2 flex items-center">
            <FaTwitter className="mr-2" />
            <a href="https://x.com/Theamitkedia" className="text-white hover:text-green-500 transition-all duration-500 hover:underline" target="_blank" rel="noopener noreferrer">X</a>
          </p>
        </div>
        <div className="flex flex-col items-center md:items-start">
          <h2 className="text-2xl font-bold mb-4">Quick Links</h2>
          <Link to="/portfolio" className="mb-2 text-white hover:text-green-500 transition-all duration-500 hover:underline">Portfolio</Link>
          <Link to="/blog" className="mb-2 text-white hover:text-green-500 transition-all duration-500 hover:underline">Blog</Link>
          <Link to="/services" className="mb-2 text-white hover:text-green-500 transition-all duration-500 hover:underline">Services</Link>
          <Link to="/about" className="mb-2 text-white hover:text-green-500 transition-all duration-500 hover:underline">About</Link>
        </div>
      </div>
      <div className="text-center mt-8">
        <p>&copy; {new Date().getFullYear()} AK. All rights reserved.</p>
        <p className="mt-2">Website Created with <span className="text-red-500">&hearts;</span> by AK</p>
      </div>
    </footer>
  );
};

export default Footer;
